export default "__VITE_PUBLIC_ASSET__8b48e767__"